var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgInfoCircled = function SvgInfoCircled(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.7349 20.1326C29.7349 18.9697 30.7046 18 31.8674 18C33.0303 18 34 18.875 34 20.1326C34 21.2954 33.0303 22.2651 31.8674 22.2651C30.7046 22.2651 29.7349 21.2954 29.7349 20.1326ZM30.606 26.9249C30.606 26.2468 31.1893 25.6635 31.8674 25.6635V25.6631C32.5454 25.6631 33.1288 26.1479 33.1288 26.8259V45.735C33.1288 46.4131 32.5454 46.9964 31.8674 46.9964C31.1893 46.9964 30.606 46.4131 30.606 45.735V26.9249Z",
    fill: "#8E8E93"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 32C62 15.4585 48.5415 2 32 2C15.4585 2 2 15.4585 2 32C2 48.5415 15.4585 62 32 62C48.5415 62 62 48.5415 62 32ZM4.7468 32C4.7468 17.7986 17.7986 4.7468 32 4.7468C46.2014 4.7468 59.2532 17.7986 59.2532 32C59.2532 46.2014 46.2014 59.2532 32 59.2532C17.7986 59.2532 4.7468 46.2014 4.7468 32Z",
    fill: "#8E8E93"
  })));
};
export default SvgInfoCircled;